import {
  set_file_data,
  set_crop,
  set_zoom,
  set_cropped_area_pxls,
  add_file,
  cropper_modal_cancel,
  set_err,
  error_modal_cancel,
  reset_state,
  close_modal,
} from './actionTypes';

export const addFile = () => ({ type: add_file });

export const cropperModalCancel = () => ({ type: cropper_modal_cancel });

export const errorModalCancel = () => ({ type: error_modal_cancel });

export const setCrop = (payload) => ({ type: set_crop, payload });

export const setZoom = (payload) => ({ type: set_zoom, payload });

export const setCroppedAreaPxls = (payload) => ({
  type: set_cropped_area_pxls,
  payload,
});

export const setErr = (msgs) => ({
  type: set_err,
  payload: msgs,
});

// payload: { file, fileSrc, zoom, initialCroppedArea }
export const setFileData = (payload) => ({ type: set_file_data, payload });

export const resetState = () => ({ type: reset_state });

export const closeModal = () => ({ type: close_modal });
